import React, { useState, useEffect } from 'react';
import StoreHomeCSS from './storeHome.module.css';
import { useNavigate } from 'react-router-dom';
//import { axiosAuthFetch } from '../../../helpers/apiActions/authFetch';
import defaultLogo from '../../../images/Logo.png';
import { API_GRAPHQL } from '../../../constants';
import Loader from '../../loader';
import axios from 'axios';

// const formatCategoryName = (name) => {
//     return name.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
//   };

const formatCategoryName = (name) => {
    return name
      .replace(/_/g, ' ') // Erstatter underscore med mellomrom
      .split(/(\s|-)/) // Deler opp teksten ved mellomrom og bindestrek, men beholder skilletegnene
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Store forbokstaver, små resten
      .join('');
  };

function StoreHome() {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [suppliers, setSuppliers] = useState([]);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [showAllProducts, setShowAllProducts] = useState(false);
    const [showFilter, setShowFilter] = useState(true);

    //console.log(products);

    const query = `query {
        categories(sort: "order:asc"){
            data{
                id
                attributes{
                    place
                }
            }
        }
        products(pagination: {limit:500}) {
            data{
                id
                attributes{
                    name
                    category{
                        data{
                            id
                            attributes{
                                place
                            }
                        }
                    }
                    visible
                    inStock
                    price
                    description
                    varenummer
                    supplier{
                        data{
                            id
                            attributes{
                                name
                                logo{
                                    data{
                                        id
                                        attributes{
                                            url
                                        }
                                    }
                                }
                            }
                        }
                    }
                    image{
                        data{
                            id
                            attributes{
                                url
                            }
                        }
                    }
                }
            }
        }
    }`

    useEffect(() => {
        setIsLoading(true);
        const getProducts = async () => {
            try {
                const response = await axios.post(API_GRAPHQL, { query });
                //console.log(response.data.data.products.data);
                const visibleProducts = response.data.data.products.data.filter(product => product.attributes.visible);
                //console.log('visible', visibleProducts)
                visibleProducts.sort((a, b) => a.attributes.name.localeCompare(b.attributes.name));
                const supplierMap = {};

                visibleProducts.forEach(product => {
                    const supplier = product.attributes.supplier.data.attributes.name;
                    if (!supplierMap[supplier]) {
                        supplierMap[supplier] = [];
                    }
                    supplierMap[supplier].push(product);
                });
                setCategories(response.data.data.categories.data);
                console.log('CATEGORIES', response.data.data.categories.data)
                setProducts(visibleProducts);
                setSuppliers(Object.keys(supplierMap).map(supplier => ({
                    name: supplier,
                    logo: supplierMap[supplier][0].attributes.supplier.data.attributes.logo.data?.attributes.url || defaultLogo,
                    products: supplierMap[supplier]
                })));
                setIsLoading(false);
            } catch (error) {
                console.error(error);
                setIsLoading(false);
            }
        };

        getProducts();
        //eslint-disable-next-line
    }, []);

    // const handleSupplierClick = (supplier) => {
    //     setSelectedSupplier(supplier);
    //     setFilteredProducts(supplier.products);
    // };

    const handleBackToStoreHome = () => {
        setSelectedSupplier(null);
        setSelectedCategory(null);
        setShowAllProducts(false);
        // setFilteredProducts([]);
    };

    const handleProductClick = (productId) => {
        navigate(`/product/${productId}`);
    };

    const handleFilterChange = (filterType, filterValue) => {
        let filtered = products;

        if(filterType === 'supplier' && filterValue) {
            filtered = filtered.filter(product => product.attributes.supplier.data.attributes.name === filterValue);
            setSelectedSupplier(filterValue);
            setSelectedCategory(null);
            setShowAllProducts(false);
        }
        if(filterType === 'category' && filterValue) {
            filtered = filtered.filter(product => product.attributes.category.data.attributes.place === filterValue);
            setSelectedCategory(filterValue);
            setSelectedSupplier(null);
            setShowAllProducts(false);
        }

        setFilteredProducts(filtered);
    };

    const handleShowAllProducts = () => {
        setFilteredProducts(products);
        setSelectedCategory(null);
        setSelectedSupplier(null);
        setShowAllProducts(true);
    }

    const handleShowFilter = () => {
        setShowFilter(!showFilter);
        console.log(showFilter);
    }

    if(isLoading) {
        return(
            <Loader />
        )
    }
    return (
        <div className={StoreHomeCSS.mainContainer}>
            <div className={StoreHomeCSS.header}>
                <div className={StoreHomeCSS.filterHeaderContainer}>
                    <div className={StoreHomeCSS.filterHeader}>Vis meny</div>
                    <div className={`${StoreHomeCSS.toggleFilterButton} ${showFilter ? StoreHomeCSS.leftArrow : StoreHomeCSS.rightArrow}`} onClick={handleShowFilter}>
                    </div>
                </div>
                <h1 className={`${StoreHomeCSS.headerTitle} my-3`}>Velkommen til vår nettbutikk!</h1>
            </div>
            <div className={StoreHomeCSS.rows}>
                {showFilter && (
                    <div className={StoreHomeCSS.column1}>
                    <div className={`${StoreHomeCSS.filter} ${showFilter ? StoreHomeCSS.showFilter : StoreHomeCSS.hiddenFilter}`}>
                        {/* <div className={`${StoreHomeCSS.filterHeader}`} onClick={handleShowFilter}>Filter</div> */}
                        <div className={StoreHomeCSS.showAllButton} onClick={handleShowAllProducts}>Vis alle produkter</div>
                        <div className={StoreHomeCSS.filterSection}>
                            <div className={StoreHomeCSS.filterHeaders}>
                                Produktkategorier
                            </div>
                            {categories.map((category) => (
                                <div key={category.id} className={`${StoreHomeCSS.cursorHover} 
                                ${selectedCategory === category.attributes.place ? StoreHomeCSS.activeFilter : ''} 
                                ${StoreHomeCSS.categoryNames}`} onClick={() => handleFilterChange('category', category.attributes.place)}>
                                    {formatCategoryName(category.attributes.place)}
                                </div>
                            ))}
                        </div>
                        <div className={StoreHomeCSS.filterSection}>
                            <div className={StoreHomeCSS.filterHeaders}>
                                Leverandører
                            </div>
                            {suppliers.map((supplier, index) => (
                                <div key={index} className={selectedSupplier === supplier.name ? StoreHomeCSS.activeFilter : StoreHomeCSS.cursorHover} onClick={() => handleFilterChange('supplier', supplier.name)}>
                                    {supplier.name}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                )}
                <div className={`${StoreHomeCSS.column2} ${showFilter ? '' : StoreHomeCSS.fullWidth}`}>
                    <div className={StoreHomeCSS.mainContent}>
                    {!selectedSupplier && !selectedCategory && !showAllProducts ? (
                            <div className={StoreHomeCSS.container}>
                            {suppliers.map((supplier, index) => {
                                const logoUrl = supplier.logo || defaultLogo;
                                return(
                                <div key={index} className={`${StoreHomeCSS.card} col-3`} onClick={() => handleFilterChange('supplier',supplier.name)}>
                                    <img className={StoreHomeCSS.supplierImage} src={logoUrl} alt={`${supplier.name} logo`}></img>
                                    <h2 className={StoreHomeCSS.h2}>{supplier.name}</h2>
                                    <p className={StoreHomeCSS.p}>PRODUKTER</p>
                                </div>
                                )
                            })}
                            </div>
                    ) : (
                        <div className={StoreHomeCSS.container}>
                            <div className={StoreHomeCSS.containerHeader}>
                                <div className={StoreHomeCSS.backButton} onClick={handleBackToStoreHome}>Tilbake til leverandører</div>
                                <div className={StoreHomeCSS.storeH1}>{showAllProducts ? "Alle produkter" : selectedSupplier ? `Våre produkter fra ${selectedSupplier}` : selectedCategory ? `Våre produkter i kategorien ${formatCategoryName(selectedCategory)}` : "Våre produkter"}</div>
                            </div>
                            <div className={StoreHomeCSS.storeContainer}>
                                {filteredProducts.map(product => {
                                    const imageUrl = product.attributes.image?.data?.attributes?.url || defaultLogo;
                                    return(
                                    <div key={product.id} className={`${StoreHomeCSS.productCard} col-3`} onClick={() => handleProductClick(product.id)}>
                                        <div className={StoreHomeCSS.productImage} style={{backgroundImage: `url(${imageUrl})` }}/>
                                        <div className={StoreHomeCSS.produktNavn}>{product.attributes.name}</div>
                                        <div className={StoreHomeCSS.cardSupplierNavn}>fra {product.attributes.supplier.data.attributes.name}</div>
                                        <div className={StoreHomeCSS.varenummer}>VN:{product.attributes.varenummer}</div>
                                        <div className={StoreHomeCSS.button}>Trykk for mer info</div>
                                    </div>
                                )
                            })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>
            
    );
}

export default StoreHome;